import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import 'reactflow/dist/style.css';
import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initSentry, SentryErrorBoundary } from '@/lib/sentry';

// No-op unless VITE_SENTRY_DSN was set at build time (see lib/sentry).
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={
        <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
          <h1>Something went wrong</h1>
          <p>The error has been reported. Please refresh the page to continue.</p>
        </div>
      }
    >
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
);
